package com.arena_web.ui.sections.eventdetail

import androidx.compose.runtime.Composable
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.*
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*

enum class MatchCenterTab {
    MatchInfo,
    Lineups,
    Media
}

@Composable
fun MatchCenterTabs(
    activeTab: MatchCenterTab,
    onTabSelected: (MatchCenterTab) -> Unit,
    modifier: Modifier = Modifier,
    // Segment horizontal padding. The mobile completed screen passes the
    // tighter 22 (Figma 8924:361800) so all three tabs fit a 390-px width.
    segmentPaddingPx: Number = 26,
) {
    val sportColors = LocalSportColors.current
    val t = LocalAppStrings.current

    Row(
        modifier = modifier
            .sBorderRadius(34)
            .sPadding(4)
            .styleModifier {
                property("position", "relative")
                property("background", AppGradients.InteractiveSecondary)
            },
        verticalAlignment = Alignment.CenterVertically
    ) {
        // Gradient outline — mask-composite overlay, matching the info card
        // border in CompletedMatchBanner / MatchInfoBanner.
        Box(
            modifier = Modifier.styleModifier {
                property("position", "absolute")
                property("inset", "0")
                property("border", "0.3px solid transparent")
                property("border-radius", s(34))
                property("background", "${AppGradients.ButtonBorderGradientPrimary} border-box")
                property("-webkit-mask", "linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)")
                property("mask", "linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)")
                property("-webkit-mask-composite", "xor")
                property("mask-composite", "exclude")
                property("pointer-events", "none")
            }
        )

        MatchCenterTab.entries.forEach { tab ->
            val tabLabel = when (tab) {
                MatchCenterTab.MatchInfo -> t.eventTabMatchInfo
                MatchCenterTab.Lineups -> t.eventTabLineups
                MatchCenterTab.Media -> t.eventTabMedia
            }
            if (tab == activeTab) {
                Box(
                    modifier = Modifier
                        .sHeight(40)
                        .sBorderRadius(28)
                        .backgroundColor(sportColors.primary)
                        .sPadding(10, segmentPaddingPx)
                        .cursor(Cursor.Pointer)
                        .onClick { onTabSelected(tab) },
                    contentAlignment = Alignment.Center
                ) {
                    SpanText(
                        tabLabel,
                        modifier = Modifier
                            .sFontSize(16)
                            .fontWeight(FontWeight.Medium)
                            .sLineHeight(18)
                            .color(sportColors.onPrimary)
                            .styleModifier { property("letter-spacing", s(0.032)) }
                    )
                }
            } else {
                Box(
                    modifier = Modifier
                        .sHeight(40)
                        .sBorderRadius(28)
                        .sPadding(8, segmentPaddingPx)
                        .cursor(Cursor.Pointer)
                        .onClick { onTabSelected(tab) },
                    contentAlignment = Alignment.Center
                ) {
                    SpanText(
                        tabLabel,
                        modifier = Modifier
                            .sFontSize(16)
                            .fontWeight(FontWeight.Medium)
                            .sLineHeight(18)
                            .color(AppColors.Text.Secondary)
                            .styleModifier { property("letter-spacing", s(0.032)) }
                    )
                }
            }
        }
    }
}
